__turbopack_context__.v({
  "image": "_1qCQBa_image",
});
